import React, { useEffect, useRef, useState } from "react";
import { InamdarHospiLogo } from "../../../assets/printAssets/InmadarHospiLogo";
import {
  getItemStockList,
  StoreExpiredItemsPrint,
} from "../../services/inventoryStockServices/InventoryStockService";
import { GeneratePrint } from "../../../common/components/printModal/GeneratePrint";

export default function ItemStockPrint(props) {
  const printRef = useRef(null);
  const [listData, setListData] = useState();
  useEffect(() => {
    getItemStockList(props?.printObject)
      .then((response) => response.data)
      .then((res) => {
        setListData(res.result);
      });
  }, [props]);

  useEffect(() => {
    listData && printRef && GeneratePrint(printRef, true);
  }, [listData]);

  return (
    <div ref={printRef}>
      <table className="w-full">
        <thead
          className=" w-full"
          style={{
            "-fs-table-paginate": "paginate",
          }}
        >
          <div className=" items-center  grid  grid-cols-3">
            <div></div>
            <div className=" text-center text-[14px] font-semibold ">
              {props?.allexpiryItemDailyVal === 1
                ? "Store Item Expiry Details"
                : props?.allexpiryItemDailyVal === 2
                ? "Items By Days"
                : props?.allexpiryItemDailyVal === 3
                ? "Current Stock"
                : ""}
            </div>
            <div className=" flex justify-end">
              <InamdarHospiLogo />
            </div>
          </div>
        </thead>
        <tbody className="w-full">
          <table className="text-[10px] w-full table-fixed">
            <colgroup>
              <col style={{ width: "4%" }} /> {/* Code */}
              <col style={{ width: "18%" }} /> {/* Item Name */}
              <col style={{ width: "4%" }} /> {/* Bal Qty */}
              {/* <col style={{ width: "8%" }} />  Store */}
              {/* <col style={{ width: "12%" }} />  Generic */}
              {/* <col style={{ width: "7%" }} />  Category */}
              {/* <col style={{ width: "6%" }} />  Item Type */}
              <col style={{ width: "8%" }} /> {/* Item Class */}
              <col style={{ width: "5%" }} /> {/* Rack */}
              <col style={{ width: "5%" }} /> {/* Shelf */}
              <col style={{ width: "5%" }} /> {/* Bin */}
              <col style={{ width: "6%" }} /> {/* MRP */}
              <col style={{ width: "6%" }} /> {/* PTR */}
              <col style={{ width: "6%" }} /> {/* Total */}
            </colgroup>

            <thead>
              <tr>
                {[
                  "Code",
                  "Item Name",
                  "Bal Qty",
                  // "Store",
                  // "Generic",
                  // "Category",
                  // "Item Type",
                  "Item Class",
                  "Rack",
                  "Shelf",
                  "Bin",
                  "Unit MRP",
                  "Unit PTR",
                  "Total Value",
                ].map((h) => (
                  <th
                    key={h}
                    className="px-0.5 border border-gray-400 border-collapse text-center break-words"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {listData?.map((data, index) => (
                <tr key={index} className="">
                  <td className="px-1 border border-gray-300 border-collapse break-words">
                    {data?.Code}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse break-words">
                    {data?.ItemName}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse text-right">
                    {data?.BalQty}
                  </td>
                  {/* <td className="px-1 border border-gray-300 border-collapse break-words">
                    {data?.StoreName}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse break-words">
                    {data?.GenericName}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse break-words">
                    {data?.Category}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse break-words">
                    {data?.ItemType}
                  </td> */}
                  <td className="px-1 border border-gray-300 border-collapse break-words">
                    {data?.ItemClass}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse">
                    {data?.Rack}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse">
                    {data?.Shelf}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse">
                    {data?.Bin}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse text-right">
                    {data?.UnitMrp}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse text-right">
                    {data?.UnitPTR}
                  </td>
                  <td className="px-1 border border-gray-300 border-collapse text-right">
                    {data?.TotalValue}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </tbody>
      </table>
    </div>
  );
}

// {
//     "Code": "1244",
//     "ItemName": "NATUROLAX (A) PWD 110 GM",
//     "BalQty": 1,
//     "StoreName": "CENTRAL PHARMACY",
//     "GenericName": null,
//     "Category": null,
//     "ItemType": "MEDICAL CONSUMABLES",
//     "ItemClass": "POWDER",
//     "Rack": null,
//     "Shelf": null,
//     "Bin": null,
//     "UnitMrp": 125,
//     "UnitPTR": 93.74,
//     "TotalValue": 93.74,
//     "count": 3942
// }
